var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMatchesgreyicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.929,
    height: 22,
    viewBox: "0 0 21.929 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1930",
    "data-name": "Group 1930",
    transform: "translate(442.855 -139.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4113",
    "data-name": "Path 4113",
    d: "M-431.785,147.892l.611-.3a4.549,4.549,0,0,1-1.524-3.95,4.488,4.488,0,0,1,1.644-3.038,4.71,4.71,0,0,1,6.137.3,4.649,4.649,0,0,1-.214,6.689,7.358,7.358,0,0,1,3.968,4.566c-.47-.168-.934-.37-1.417-.5a4.507,4.507,0,0,0-2.681.154.615.615,0,0,1-.383,0,4.575,4.575,0,0,0-6.156,3.529,4.5,4.5,0,0,0,1.264,4.044c.6.625,1.23,1.222,1.846,1.833.049.049.1.1.151.158a.871.871,0,0,1-.64.225q-2.784,0-5.568,0c-2.365,0-4.73-.011-7.1.008a.959.959,0,0,1-1.012-1.059,7.265,7.265,0,0,1,4.145-6.434c.049-.025.095-.057.145-.087a4.626,4.626,0,0,1,.009-6.736A4.631,4.631,0,0,1-431.785,147.892Z",
    transform: "translate(0 0)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4114",
    "data-name": "Path 4114",
    d: "M-140.894,460.572a2.824,2.824,0,0,1,1.839.522.264.264,0,0,0,.382-.007,2.817,2.817,0,0,1,3.411.106,2.775,2.775,0,0,1,.645,3.271,3.239,3.239,0,0,1-.572.822c-.979,1.006-1.978,1.993-2.973,2.984a.909.909,0,0,1-1.4,0c-1-1-2-1.99-2.992-3a2.827,2.827,0,0,1-.281-3.693A2.517,2.517,0,0,1-140.894,460.572Z",
    transform: "translate(-286.583 -307.151)",
    fill: "#707070"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchesgreyicon);
export default __webpack_public_path__ + "static/media/matchesgreyicon.ada182e04002ce343c749d784f1def1b.svg";
export { ForwardRef as ReactComponent };